import React, { useMemo } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import Caption from 'LuxKit/Typography/Caption'
import useCurrentLoyaltyTier from 'loyalty/hooks/useCurrentLoyaltyTier'
import FormatDecimal from 'components/utils/Formatters/FormatDecimal'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import { useAppSelector } from 'hooks/reduxHooks'

const ProgressTrack = styled.div`
  position: relative;
  width: 100%;
  height: ${rem(10)};
  background: ${props => props.theme.palette.neutral.default.six};
  border-radius: ${props => props.theme.borderRadius.round};
  border: ${rem(2)} solid ${props => props.theme.palette.neutral.default.six};
  display: flex;
  flex-direction: row;
  align-items: center;
`

const ProgressBar = styled.div`
  width: var(--progress, 0%);
  border-radius: ${props => props.theme.borderRadius.round};
  height: 100%;

  &.tier-bronze { background: ${props => props.theme.palette.product.loyalty.bronze.normalBackground}; }
  &.tier-silver { background: ${props => props.theme.palette.product.loyalty.silver.normalBackground}; }
  &.tier-gold { background: ${props => props.theme.palette.product.loyalty.gold.normalBackground}; }
  &.tier-platinum { background: ${props => props.theme.palette.product.loyalty.platinum.normalBackground}; }
`

const EndCap = styled.div`
  position: absolute;
  height: 100%;
  aspect-ratio: 1;
  right: 0;
  border-radius: ${props => props.theme.borderRadius.round};

  &.tier-bronze {
    background-color: ${props => props.theme.palette.product.loyalty.bronze.normalBackground};
  }

  &.tier-silver {
    background-color: ${props => props.theme.palette.product.loyalty.silver.normalBackground};
  }

  &.tier-gold {
    background-color: ${props => props.theme.palette.product.loyalty.gold.normalBackground};
  }

  &.tier-platinum {
    background-color: ${props => props.theme.palette.product.loyalty.platinum.normalBackground};
  }
`

function LoyaltyAccountNextTierProgressBar() {
  const {
    totalCreditsForTierRetention = 0,
    totalCreditsForTierUpgrade = 0,
    statusCredits = 0,
  } = useAppSelector(state => state.loyalty.account.data) ?? {}
  const [tier, tierName, nextTier, nextTierName] = useCurrentLoyaltyTier()

  const isRetentionOnly = !nextTier
  const progressPercent = useMemo(() => {
    return Math.min((statusCredits / totalCreditsForTierUpgrade) * 100, 100)
  }, [statusCredits, totalCreditsForTierUpgrade])

  const retentionPercent = useMemo(() => {
    return Math.min((totalCreditsForTierRetention / totalCreditsForTierUpgrade) * 100, 100)
  }, [totalCreditsForTierRetention, totalCreditsForTierUpgrade])

  return <VerticalSpacer gap={8}>
    <ProgressTrack>
      <ProgressBar className={`tier-${tier}`} style={{ '--progress': `${isRetentionOnly ? retentionPercent : progressPercent}%` }} />
      <EndCap className={`tier-${nextTier ?? tier}`} />
    </ProgressTrack>
    <Caption variant="small" format="uppercase" weight="bold" align="end">
      {isRetentionOnly ? `retain ${tierName}` : `reach ${nextTierName}`}<br />
      <FormatDecimal value={isRetentionOnly ? totalCreditsForTierRetention : totalCreditsForTierUpgrade} />
    </Caption>
  </VerticalSpacer>
}
export default LoyaltyAccountNextTierProgressBar
